// extracted by mini-css-extract-plugin
module.exports = {"root":"_6eb00b8e53--root--9US78"};